import LineDetailProductCard from "./LineDetailProductCard";

export default LineDetailProductCard;
